export const MultipleSelection = 'MultipleSelection';
export const AllSelection = 'AllSelection';
